import Accordion from "../../../../src/custom/common/accordion";
import * as React from 'react';
export default {
  Accordion,
  React
};